import React from 'react';

import { Button } from 'components/ui';
import { cx } from 'helpers/StylingHelpers';
import { useUser } from 'hooks/data/useUser';

import type { IBmsmInfo } from 'types';

import styles from './ProductAddToCart.module.scss';

interface Props {
  className?: string,
  withWideBuyMoreButton?: boolean,
  inline?: boolean,
  //
  bmsmInfo?: IBmsmInfo,
  //
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const ProductBuyMoreButton = (props: Props) => {
  const {
    className,
    withWideBuyMoreButton,
    inline = false,
    //
    bmsmInfo,
    //
    onClick
  } = props;

  const {
    geniusPriceLabel,
    priceLabel
  } = bmsmInfo || {};

  // Hooks

  const { data: user } = useUser({ isOptional: true });

  const {
    isGeniusUser = false
  } = user || {};

  const displayedPriceLabel = React.useMemo(() => {
    return (!!geniusPriceLabel && isGeniusUser) ? geniusPriceLabel : priceLabel;
  }, [isGeniusUser, geniusPriceLabel, priceLabel]);

  // Render

  return (
    <Button
      dataTestId="buy-more-btn"
      className={cx(
        styles.btn,
        styles.buyMoreBtn,
        { [styles.wide]: withWideBuyMoreButton },
        { [styles.inline]: inline },
        className
      )}
      onClick={onClick}
      //
      aria-label="Buy more, save more"
    >
      {displayedPriceLabel}
    </Button>
  );
};

export default ProductBuyMoreButton;
